import React from 'react'
import I18N from '@leverege/i18n'

import StoreTrafficModel from './StoreTrafficModel'
import StoreTraffic from './StoreTraffic'

const id = 'ps.dataViewers.StoreTrafficSupportDataViewer'

const { tf, tfIcon } = I18N.ns( id )

export default {
  id,
  type : 'ps.StoreTrafficSupport',
  name : tf( 'name' ),
  icon : tfIcon( 'historyIcon', 'fa fa-history fa-fw' ),
  location : 'none',
  matches : { type : 'ItemInfoDataViewer', objectType : 'store' },
  createSettings : ( props ) => {
    return StoreTrafficModel.create()
  },
  render : ( props ) => {
    return React.createElement( StoreTraffic, props )
  },
  getDefaultCardContentOptions : { height : 'auto' },
}
